import repository from '@/repositories/repository'

const resource = ({ consumer, consumerLoan }) => {
  return `consumers/${consumer}/loans/${consumerLoan}/inventories`
}
const resourceB = 'consumers/loans/inventories'

export default {
  index ({ consumer, consumerLoan }, params) {
    return repository.get(resource({ consumer, consumerLoan }), { params })
  },
  verify ({ consumer, consumerLoan }, data) {
    return repository.post(`${resource({ consumer, consumerLoan })}/verify`, data)
  },
  delete (id) {
    return repository.delete(`${resourceB}/${id}/delete`)
  },
  edit (id) {
    return repository.post(`${resourceB}/${id}/edit`)
  },
  store ({ consumer, consumerLoan }, data) {
    return repository.post(resource({ consumer, consumerLoan }), { data })
  },
  insert (data) {
    return repository.post(`${resourceB}`, { data })
  },
  update ({ consumer, consumerLoan }, { id, data }) {
    return repository.put(`${resource({ consumer, consumerLoan })}/${id}`, data)
  },
  export () {
    return repository.get(`${resourceB}/export`)
  },
  countExport () {
    return repository.get(`${resourceB}/export/count`)
  },
  import ({ data, columns, unique }) {
    return repository.post(`${resourceB}/import`, { data, columns, unique })
  },
  weekly (params) {
    return repository.get(`${resourceB}/weekly`, { params })
  },
  monthly (params) {
    return repository.get(`${resourceB}/monthly`, { params })
  },
  yearly (params) {
    return repository.get(`${resourceB}/yearly`, { params })
  },
  weeklyBranch (storeId, params) {
    return repository.get(`${resourceB}/weekly/${storeId}`, { params })
  },
  monthlyBranch (storeId, params) {
    return repository.get(`${resourceB}/monthly/${storeId}`, { params })
  },
  yearlyBranch (storeId, params) {
    return repository.get(`${resourceB}/yearly/${storeId}`, { params })
  },
  weeklyAll (params) {
    return repository.get(`${resourceB}/all/weekly`, { params })
  },
  monthlyAll (params) {
    return repository.get(`${resourceB}/all/monthly`, { params })
  },
  yearlyAll (params) {
    return repository.get(`${resourceB}/all/yearly`, { params })
  },
}
